export default __webpack_public_path__ + "static/media/detail_big_9_5.ae153baf.jpg";